<template>
  <div id="app">
    <!-- 头部导航 -->
    <header class="header" :class="{ 'header-fixed' : headerFixed }" style="background-color: rgb(9,172,248); ">
      <el-row>
          <el-col :md="16" :sm="12" class="logo">
            <a href="#"><img src="./assets/imfbp_logo.png" alt="Logo"></a>
            <span class="topTitle">我的工作台</span>
          </el-col>
          <el-col :md="8" :sm="12" class="person-set">
            <user></user>
            <el-button type="text"
                       @click="openDialog"
                       style="font-szie:18px">
                       <i v-if="!addCard" class="el-icon-plus" style="color:#FFFFFF"></i>
                       <i v-if="addCard" class="el-icon-close" style="color:#FFFFFF"></i>
            </el-button>
          </el-col>
      </el-row>
    </header>

    <main>
          <!-- 左侧导航 -->
          <mainNav :class="{ 'left-fixed' : leftFixed }"></mainNav>

          <!-- 右侧主内容区 -->
          <div  class="main-right" >
            <transition name="fade">
              <router-view class="view" style="display:flex;flex-direction: column;padding-bottom:100px"></router-view>
            </transition>
          </div>
    </main>

    <sideDialog :show="addCard"></sideDialog>

  </div>
</template>

<script>

import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import $ from 'jquery'

// 引入组件
import user from 'components/user.vue'
import mainNav from 'components/mainNav.vue'
import sideDialog from 'components/sideDialog.vue'

Vue.use(Element)

export default {
  name: 'app',
  data: function (){
    return {
      active:true,
      headerFixed: true,
      leftFixed: true,
      addCard: false
    }
  },
  components:{
    user: user,
    mainNav: mainNav,
    sideDialog: sideDialog
  },
  methods: {
    openDialog(){
      this.addCard = !this.addCard
    }
  }
}
</script>

<style>

body{overflow: hidden;position:absolute;width: 100%;top:0;bottom: 0;margin: 0;}
#app {

  margin: 0 auto;
  font-family: "Helvetica Neue","PingFang SC",Arial,sans-serif;
  position: relative;
  height: 100%;
/*  max-width: 1200px;*/


}
/* 头部导航 */
header.header{padding-top: 0;z-index: 1000;min-width: 1200px;transition: all 0.5s ease;  background-color: rgb(9,172,248);  box-shadow: 0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04);  }
header.header-fixed{position: relative;top: 0;left: 0;height: 60px;width: 100%}
header .logo{height: 60px; line-height: 60px; text-align: left;}
header .logo>a{height: 58px; line-height: 58px; display: inline-block;}
header .logo img{height: 32px; vertical-align: middle; display: inline-block; padding:0 20px; margin-top: -4px;}
header .person-set{height: 60px; line-height: 60px; text-align: right; }
header .person-set div,header .person-set span,header .person-set button{color: #ffffff;width: 100px!important;height: 60px;}
header .person-set button:hover{background: rgb(9,159,229);}
header .topTitle {
    font-family: "Helvetica Neue","PingFang SC",Arial,sans-serif;
    font-size: 18px;
    color: #FFFFFF;
    padding: 4px 0 4px 20px;
    border-left: 1px solid rgba(255,255,255,0.5);
}
header.card-name{min-width: 1200px;padding-top: 0;}
/* 主内容区 */
main{background-color: #FCFCFC;position: relative;height: 100%}
main .main-right{ background-color: #fafafa; padding: 0;overflow: scroll;height: 100%}
main .el-menu{background-color: transparent!important;}

/*  */
.router-link{display:inline-block;width:100%;height:100%;text-align:center;color:#475669;text-decoration: none; }
.is-active .router-link{color:#20a0ff;  }

/* 单选框 */
  .el-form-item .el-radio+.el-radio {
    margin-left: 30px!important;
  }
  /* 路由切换动效 */
  /*.fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }*/

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-active {
    opacity: 0;
    transform: translateY(30px);
  }

/* 导航栏菜单选中效果 */
  /*.isActive{color: #ffffff!important;border-left:4px solid #09ACF8}*/
   #app main .aside .is-active{color: #475669;}

  /* 卡片 */
  .el-card{overflow: visible!important;}
  .formImg{
    width: 76px;
    height: 76px;
    float: left;
    margin-top: -16px;
    margin-right: 10px;
  }
  /*reset el-dialog css*/
  div.el-dialog{
    position: fixed;
    border-radius: 0;
    left: initial;
    right: 0;
    height: 100%;
    transform: translateX(0);
  }
</style>



// WEBPACK FOOTER //
// App.vue?345cf652